<template>
 
         
        <el-form ref="form" label-width="450px" :model="form" size="small" :rules="rules">
        <div style="text-align:center;padding:20px 0; height:30px;">
            <b>Project and End User Information</b>
        </div>
       
        <div>
          
            <el-form-item label="Project Name" prop="ProjectName">
                <el-input v-model="form.ProjectName" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="date of receiving project" prop="DateofReceivingProject">
                <el-input v-model="form.DateofReceivingProject" :disabled="true"></el-input>
            </el-form-item>

             <el-form-item label="last contact date" prop="LastContactDate">
                <el-input v-model="form.LastContactDate" :disabled="true"></el-input>
            </el-form-item>

             <el-form-item label="latest project status update" prop="LatestProjectStatusUpdate">
                <el-input v-model="form.LatestProjectStatusUpdate" :disabled="true"></el-input>
            </el-form-item>

             <el-form-item label="expected date of opening tender" prop="ExpectedDateofOpeningTender">
                <el-input v-model="form.ExpectedDateofOpeningTender" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="expected date of closing tender" prop="ExpectedDateofClosingTender">
                <el-input v-model="form.ExpectedDateofClosingTender" :disabled="true"></el-input>
            </el-form-item>

             <el-form-item label="expected date of deployment/installation" prop="ExpectedDateofDeploymentInstallation">
                <el-input v-model="form.ExpectedDateofDeploymentInstallation" :disabled="true"></el-input>
            </el-form-item>

             <el-form-item label="Developer">
                <el-input v-model="form.Developer" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="Project detail location (Address, City, Province, Country)" prop="ProjectLocation">
                <el-input v-model="form.ProjectLocation" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="End User Name" prop="EndUserName">
                <el-input v-model="form.EndUserName" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="End User Website">
                <el-input v-model="form.EndUserWebsite" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="SIP PBX Brand">
                <el-input v-model="form.SIPPBXBrand" placeholder="If no SIP PBX , please enter NO" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="Tested Akuvox Intercom to End User">
                <el-input v-model="form.TestedAkuvoxIntercomtoEndUser"  placeholder="YES？NO？" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="When to Deploy/Ship" prop="WhentoDeploy">
                <el-input v-model="form.WhentoDeploy" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="One-off Purchase Order or Partial Orders" prop="OneoffPurchaseOrderorPartialOrders">
                <el-input v-model="form.OneoffPurchaseOrderorPartialOrders" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="Win Rate" prop="WinRate">
                <el-input v-model="form.WinRate" :disabled="true"></el-input>
            </el-form-item>
           
            <div style="padding:20px 0;border-bottom:1px solid #e2e2e2;margin-bottom:20px;">
            <p class="title">Brief Description of Project</p>
            </div>
            <div class="html-text-content" v-html="data.BriefDescriptionofProject"></div>
            <br><br>

            <div style="text-align:center;padding:20px 0; height:30px;">
            <b>Reseller/SI Information</b>
            </div>
             
            <el-form-item label="Company Name of Reseller/SI" prop="CompanyNameofReseller">
                <el-input v-model="form.CompanyNameofReseller" :disabled="true"></el-input>
            </el-form-item>
                        <br>
            <div style="text-align:center;padding:20px 0; height:30px;">
            <b>Contact</b>
            </div>

            <el-form-item label="Name">
                <el-input v-model="form.Name" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="Tel">
                <el-input v-model="form.Tel" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="Email">
                <el-input v-model="form.Email" :disabled="true"></el-input>
            </el-form-item>
            <br><br>

            <div style="text-align:center;padding:20px 0; height:30px;">
            <b>Akuvox Proposal</b>
            </div>

            <template v-for="(item,index) in form.Devices">

                <el-form-item :key="item.index" label="Model" :prop="'Devices.'+index+'.Model'" :rules="{
                required: true, message: 'please enter a model', trigger: 'blur'}">
                    <el-input v-model="item.Model"  :disabled="true"></el-input><span style=" position: absolute; top: 1%; right: 2%;"> </span>
                </el-form-item>

                <el-form-item :key="item.index" label="Quantity" :prop="'Devices.'+index+'.Quantity'" :rules="{
                required: true, message: 'please enter a quantity', trigger: 'blur'}" >
                    <el-input v-model="item.Quantity"  :disabled="true"></el-input><span style=" position: absolute; top: 1%; right: 2%;"> </span>
                </el-form-item>  

                <el-form-item :key="item.index" label="Comments" :prop="'Devices.'+index+'.Comments'" :rules="{
                required: true, message: 'please enter a comments', trigger: 'blur'}" >
                    <el-input v-model="item.Comments"  :disabled="true"></el-input><span style=" position: absolute; top: 1%; right: 2%;"> </span>
                </el-form-item>  
            </template>
            <br><br>
             
            <div style="text-align:center;padding:20px 0; height:30px;">
            <b>Competitors Information</b>
            </div>
            
            <div style="padding:20px 0;border-bottom:1px solid #e2e2e2;margin-bottom:20px;">
            <p class="title">Key Points of Akuvox to Win</p>
            </div>
            <div  class="html-text-content" v-html="data.KeyPointsofAkuvoxtoWin"></div>
            <br><br>
            <br><br>

                <template v-for="(item,index) in form.CompetitorDevices">

                <el-form-item :key="item.index" label="Competitor and its Model" :prop="'CompetitorDevices.'+index+'.Model'" :rules="{
                required: true, message: 'please enter competitor and its model', trigger: 'blur'}">
                    <el-input v-model="item.Model" :disabled="true"></el-input><span style=" position: absolute; top: 1%; right: 2%;"> </span>
                </el-form-item>

                <el-form-item :key="item.index" label="Quantity" :prop="'CompetitorDevices.'+index+'.Quantity'" :rules="{
                required: true, message: 'please enter a quantity', trigger: 'blur'}" >
                    <el-input v-model="item.Quantity" :disabled="true"></el-input><span style=" position: absolute; top: 1%; right: 2%;"> </span>
                </el-form-item>  

                <el-form-item :key="item.index" label="Comments" :prop="'CompetitorDevices.'+index+'.Comments'" :rules="{
                required: true, message: 'please enter a comments', trigger: 'blur'}" >
                    <el-input v-model="item.Comments" :disabled="true"></el-input><span style=" position: absolute; top: 1%; right: 2%;"> </span>
                </el-form-item>  
            </template>

            <br><br>
            <div style="padding:20px 0;border-bottom:1px solid #e2e2e2;margin-bottom:20px;">
            <p class="title">Additional Info</p>
            </div>
            <div  class="html-text-content" v-html="data.AdditionalInfo"></div>
            <br><br>
            <br><br>
         
            <el-form-item label="What help you need from Akuvox to win the project?">
                <el-input v-model="form.NeedHelp" :disabled="true"></el-input>
            </el-form-item>
          
            <el-form-item label="Conclusion">
                <el-input v-model="form.Conclusion" :disabled="true"></el-input>
            </el-form-item>
            
            <br><br>
        </div>
        <div style="float:right;">
            <el-button @click="submit()" type="primary">Close</el-button>
        </div>
       <br><br> 
    </el-form>
</template>

<script>
export default {
    props:{
        id:{}
    },
    data () {
        return {
            data:{},
            type:"",
            form:{
                ProjectName:"",
                DateofReceivingProject:"",
                LastContactDate:"",
                LatestProjectStatusUpdate:"",
                ExpectedDateofOpeningTender:"",
                ExpectedDateofClosingTender:"",
                ExpectedDateofDeploymentInstallation:"",
                Developer:"",

                ProjectLocation:"",
                EndUserName:"",
                EndUserWebsite:"",
                SIPPBXBrand:"",
                
                TestedAkuvoxIntercomtoEndUser:"",
                WhentoDeploy:"",
                OneoffPurchaseOrderorPartialOrders:"",
                WinRate:"",
                CompanyNameofReseller:"",

                Name:"",
                Tel:"",
                Email:"",
                Devices:[{
                    Model:"",
                    Quantity:"",
                    Comments:""
                }],
                CompetitorDevices:[{
                    Model:"",
                    Quantity:"",
                    Comments:""
                }],
                Conclusion:"",
                NeedHelp:""
            },
            rules:{
                ProjectName:[{ required: true, message: 'Please enter your Project name', trigger: 'blur' }],
                ProjectLocation:[{ required: true, message: 'Please enter your Project Location', trigger: 'blur' }],
                EndUserName:[{ required: true, message: 'Please enter your end user name', trigger: 'blur' }],
                WhentoDeploy:[{ required: true, message: 'Please fill in when to Deploy', trigger: 'blur' }],
                WinRate:[{ required: true, message: '>70% / <70%,>40% / <40%', trigger: 'blur' }],
                CompanyNameofReseller:[{ required: true, message: 'Please fill in a company name of reseller', trigger: 'blur' }],
                KeyPointsofAkuvoxtoWin:[{ required: true, message: 'Please fill in a key points of Akuvox to win', trigger: 'blur' }],
                DateofReceivingProject:[{ required: true, message: 'Please enter your date of receiving project', trigger: 'blur' }],
                LastContactDate:[{ required: true, message: 'Please enter your last contact date', trigger: 'blur' }],
                LatestProjectStatusUpdate:[{ required: true, message: 'Please select your latest project status update', trigger: 'blur' }],
                ExpectedDateofDeploymentInstallation:[{ required: true, message: 'Please enter your expected date of deployment/installation', trigger: 'blur' }]
            }
        };
    },
    mounted () {
    },
    created () {
        if(this.id)
            this.$http.get("getProjectRegistrationInfo",{
                ID:this.id
            },(data)=>{
                this.data = data.data;
                this.form.ProjectName = this.data.ProjectName;

                this.form.DateofReceivingProject = this.data.DateofReceivingProject;
                this.form.LastContactDate = this.data.LastContactDate;
                this.form.LatestProjectStatusUpdate = this.data.LatestProjectStatusUpdate;
                this.form.ExpectedDateofOpeningTender = this.data.ExpectedDateofOpeningTender;
                this.form.ExpectedDateofClosingTender = this.data.ExpectedDateofClosingTender;
                this.form.ExpectedDateofDeploymentInstallation = this.data.ExpectedDateofDeploymentInstallation;
                this.form.Developer = this.data.Developer;

                this.form.ProjectLocation = this.data.ProjectLocation;
                this.form.EndUserName = this.data.EndUserName;
                this.form.EndUserWebsite = this.data.EndUserWebsite;
                this.form.SIPPBXBrand = this.data.SIPPBXBrand;

                this.form.TestedAkuvoxIntercomtoEndUser = this.data.TestedAkuvoxIntercomtoEndUser;
                this.form.WhentoDeploy = this.data.WhentoDeploy;
                this.form.OneoffPurchaseOrderorPartialOrders = this.data.OneoffPurchaseOrderorPartialOrders;
                this.form.WinRate = this.data.WinRate;
                this.form.CompanyNameofReseller = this.data.CompanyNameofReseller;

                this.form.Name = this.data.Name;
                this.form.Tel = this.data.Tel;
                this.form.Name = this.data.Name;
                this.form.Conclusion = this.data.Conclusion;
                this.form.NeedHelp = this.data.NeedHelp;
                this.form.Devices = this.data.Devices;
                this.form.CompetitorDevices = this.data.CompetitorDevices;
            });
    },
    methods:{
        submit () {
            this.$router.push("/projectRegistration");
        },
        addDevice () {
            this.$set(this.form.Devices,this.form.Devices.length,{
                Model:"",
                Quantity:"",
                Comments:""
            });
        },
        deleteDevice (index) {
            this.$delete(this.form.Devices,index);
        },
        addCompetitorDevice () {
            this.$set(this.form.CompetitorDevices,this.form.CompetitorDevices.length,{
                Model:"",
                Quantity:"",
                Comments:""
            });
        },
        deleteCompetitorDevice (index) {
            this.$delete(this.form.CompetitorDevices,index);
        }
    }
};
</script>
<style lang="less" scoped>
    .title{
        padding: 20px 0 0px 10px;
        display: block;
    }
    .html-text-content{
        table td,table th {
            border-bottom: 1px solid #ccc;
            border-right: 1px solid #ccc;
            
        }
        padding-left: 20px;
    }
</style>

